module.exports = __webpack_public_path__ + "img/team-mosaic-03.2fdfcb2d.jpg";